module.exports = __webpack_public_path__ + "04589148f2fac4658b8a5d7330893095.jpg";